import ApplicationController from './application_controller'
import Rails from '@rails/ujs'
import { useDispatch } from 'stimulus-use'

const EMPTY_COUNTER_PLACEHOLDER = '-'

export default class extends ApplicationController {
  static targets = ['counter']
  static values = { searchParams: String, refreshUrl: String }

  initialize() {
    useDispatch(this)
  }

  doConnect() { }

  afterConnect() {
    [this.elemsIncluded, this.elemsMapped] = this.retrieveElemsIncludedVars()
  }

  reconnect(event) {
    this.connect()
    setTimeout(() => { this.dispatch('reconnect-complete') }, 0)
  }

  onSearchUpdated(event) {
    if (!event.detail) return

    this.searchParamsValue = event.detail.params
    this.retrieveCountsWithSearchParams()
  }

  retrieveCountsWithSearchParams() {
    if (this.hasSearchParamsValue) {
      this.retrieveCounts(this.searchParamsValue)
    }
  }

  retrieveCounts(paramData = {}) {
    this.removeElementsCount()

    Rails.ajax({
      type: 'POST',
      url: this.refreshUrlValue,
      dataType: 'script',
      data: paramData,
      success: (data) => {
        this.updateElementsCount(data)
      }
    })
  }

  retrieveElemsIncludedVars() {
    const elemsIncluded = new Set()
    const elemsMapped = {}

    this.counterTargets.forEach((elem) => {
      const countName = this.getParam(elem, 'name')
      elemsIncluded.add(countName)
      elemsMapped[countName] = elem
    })

    return [elemsIncluded, elemsMapped]
  }

  updateElementsCount(countData) {
    const data = Object.entries(countData.counts)
    const numberFormatter = new Intl.NumberFormat()

    for (const [name, count] of data) {
      if (this.elemsIncluded.has(name)) {
        const elem = this.elemsMapped[name]
        elem.innerHTML = numberFormatter.format(count)
      }
    }
  }

  removeElementsCount() {
    this.counterTargets.forEach((counter) => {
      counter.innerHTML = EMPTY_COUNTER_PLACEHOLDER
    })
  }
}
